var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer_service",style:({top: _vm.position + 'px'}),on:{"click":_vm.toCustomerService}})}
var staticRenderFns = []

export { render, staticRenderFns }